import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ExternalLink, TrendingUp } from "lucide-react";
import { useTranslation } from "react-i18next";

const BitgetPartnership = () => {
  const { t } = useTranslation();
  
  return (
    <section className="py-20 bg-secondary/20">
      <div className="container px-4">
        <Card className="p-8 md:p-12 bg-card/40 backdrop-blur-xl border-border relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-opal opacity-20 rounded-full blur-3xl" />
          <div className="relative z-10 text-center space-y-6">
            <div className="flex justify-center mb-4">
              <div className="p-4 bg-gradient-primary rounded-full">
                <TrendingUp className="w-12 h-12" />
              </div>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold">
              {t('bitget.title').split('<span>')[0]}
              <span className="bg-gradient-primary bg-clip-text text-transparent">
                {t('bitget.title').split('<span>')[1]?.split('</span>')[0]}
              </span>
              {t('bitget.title').split('</span>')[1]}
            </h2>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
              {t('bitget.description').split('<span>')[0]}
              <span className="font-semibold text-foreground">{t('bitget.description').split('<span>')[1].split('</span>')[0]}</span>
              {t('bitget.description').split('</span>')[1].split(':X')[0]}
              <span className="gradient-x-animated">:X</span>
              {t('bitget.description').split(':X')[1]}
            </p>
            
            <div className="max-w-2xl mx-auto mt-8 p-6 bg-gradient-primary/10 border border-primary/20 rounded-lg">
              <h3 className="text-lg font-semibold mb-3 flex items-center justify-center gap-2">
                <span className="text-primary">✨</span> Exclusive Member Benefits
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                When you join Bitget through our referral link, you gain access to reduced trading fees—maximizing your profits on every trade. Lower fees mean you keep more of your gains while executing our premium signals, giving you a competitive edge in the market.
              </p>
            </div>
            
            <p className="text-sm text-muted-foreground">
              <a href="#pricing-features" className="text-primary hover:underline">{t('bitget.linkText')}</a>
            </p>
            <Button 
              size="lg" 
              className="mt-6"
              asChild
            >
              <a 
                href="https://www.abcdstable.com/de/referral/register?clacCode=X6J4B67H&from=%2Fde%2Fevents%2Freferral-all-program&source=events&utmSource=PremierInviter"
                target="_blank"
                rel="noopener noreferrer"
                className="gap-2"
              >
                {t('bitget.button')}
                <ExternalLink className="w-4 h-4" />
              </a>
            </Button>
          </div>
        </Card>
      </div>
    </section>
  );
};

export default BitgetPartnership;
